import React, { useEffect, useRef, useState } from 'react'
import { defaultStyles, FileIcon } from 'react-file-icon'
import styles from './image_with_text_area.module.scss'
import Spinner from '../Spinner'
import { images } from '../../assets'

const ImageWithTextArea = (props) => {
  const {
    name,
    placeholder,
    value,
    onChange,
    onBlur,
    className,
    disabled,
    isLoading,
    formikProps,
    fieldInfo,
  } = props
  const [selectedFiles, setSelectedFiles] = useState([])
  const [selectedFilesData, setSelectedFilesData] = useState([])
  const attachmentRef = useRef(null)
  useEffect(() => {
    console.log('selectedFilesData ', selectedFilesData)
  }, [selectedFilesData])
  useEffect(() => {
    console.log('value?.files ', value?.files)
    if (value?.files) {
      setSelectedFiles(value?.files)
      setSelectedFilesData(updateFilesData(value?.files))
    }
  }, [value?.files])

  const handleBlur = (e) => {
    console.log('handleBlur triggered', e)
    try {
      let currentValue = value ? { ...value } : {}
      currentValue.files = selectedFiles
      formikProps.setFieldValue(fieldInfo.slug, currentValue)
      //formikProps.setFieldTouched(fieldInfo.slug,true)
      onBlur(e)
    } catch (e) {
      console.log('handleBlur triggered e', e)
    }
  }
  const updateFilesData = (files) => {
    console.log('updateFilesData files', files)
    return files.map((file) => {
      const type = file.type.split('/')
      let data = {
        type: file.type,
        name: file.name,
      }
      if (type[0] === 'image') {
        data.url = URL.createObjectURL(file, { autoRevoke: false })
      }
      return data
    })
  }
  const handleImageChange = (e) => {
    e.preventDefault()
    console.log('handleImageChange currentFile', e.target.files)
    const arr = Array.from(e.target.files)
    setSelectedFiles([...selectedFiles, ...arr])
    setSelectedFilesData([...selectedFilesData, ...updateFilesData(arr)])

    /* reader.onloadend = () => {
            const type = currentFile.type.split('/')
            setFile(currentFile)
            setFileType(type[0])
            setShowUploadingModal(true)
            console.log('handleImageChange type[0]', type[0])
            uploadImage(currentFile, type[0])
        }
        reader.readAsDataURL(currentFile) */
  }

  return (
    <div className={className} onBlur={handleBlur}>
      {isLoading ? (
        <Spinner color="white" isLoading />
      ) : (
        <div>
          <div>
            <textarea
              name={name}
              placeholder={placeholder}
              value={value?.text || ''}
              className={`form-control ${styles.textArea}`}
              onChange={(e) => {
                console.log('textarea e.target.value', e.target.value)
                let currentValue = value ? { ...value } : {}
                currentValue.text = e.target.value
                formikProps.setFieldValue(fieldInfo.slug, currentValue)
              }}
              //onBlur={onBlur}
              disabled={disabled}
            />
          </div>
          <div className={styles.attachmentSection}>
            <div className={styles.icons}>
              {selectedFilesData.map((file) => {
                const type = file.type.split('/')
                return (
                  <div>
                    {type[0] === 'image' ? (
                      <div className={styles.icon}>
                        <img src={file.url} className={styles.image} />
                      </div>
                    ) : (
                      <div className={styles.icon}>
                        <div className={styles.fileIcon}>
                          <FileIcon
                            extension={type[type.length - 1]}
                            {...defaultStyles[type[type.length - 1]]}
                          />
                        </div>
                        <span className={styles.fileName}>{file.name}</span>
                      </div>
                    )}
                  </div>
                )
              })}
            </div>
            <div onClick={() => attachmentRef.current.click()}>
              <input
                className={styles.file_input}
                type="file"
                multiple
                ref={attachmentRef}
                onChange={handleImageChange}
              />
              <img
                src={images.attachmentIcon}
                className={styles.attachmentIcon}
                alt="attachment"
              />
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default ImageWithTextArea
